module.exports = __webpack_public_path__ + "img/farzana-christopher-66.41ef51ed.jpg";